import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Link,
  Route,
  Switch,
  NavLink,
} from "react-router-dom";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Container,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { FiHome } from "react-icons/fi";
import { Avatar, Menu, MenuItem } from "@mui/material";

// Icons
import PersonIcon from '@mui/icons-material/Person';
import { FiLogOut } from "react-icons/fi";

// Styles
import "./stylesheet.css";
import "./toggleSwitch.css";
import "./App.css";
import "./ButtonStyle.scss";
import "./loding.scss";

// Pages and Components
import LodingComponent from "./loding";
import Home from "./components/pages/Home";
import SubscriptionForm from "./components/pages/Subscriptionfee/Create";
import SubscriptionIndex from "./components/pages/Subscriptionfee/Index";

//user 
import UserForm from "./components/pages/User/Create";
import LoginPage from "./components/pages/LoginPage";
import CheckProfile from "./components/pages/CheckProfile";
import CompleteProfile from "./components/pages/CompleteProfile";
import SignupPage from "./components/pages/SignupPage";
import UserPlan from "./components/pages/User/UserPlan";
import Payment from "./components/pages/User/Payment";
import EditUserProfile from "./components/pages/User/Edit";
import UserDashboard from "./components/pages/User/UserDashBoard";

//Horoscope 
import PlanetViewPage from "./components/pages/Horoscope/Positions";

//Logout
// import Logout from "./Logout";

const App = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const UserId = 1;
  return (
    <Router>
      <AppBar position="static" style={{ backgroundColor: "#002029", height: "55px" }}>
        <Toolbar style={{ minHeight: "55px", padding: "0 24px", position: "relative" }}>
          <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerOpen}>
            <MenuIcon />
          </IconButton>

          <Typography
            variant="h6"
            component="div"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Link
                to="/Home"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <FiHome style={{ marginRight: "8px" }} />
                <Typography
                  className="dual-text"
                  component="div"
                  style={{
                    marginLeft: "14px",
                    fontWeight: "bolder",
                    textTransform: "uppercase",
                    color: "whitesmoke",
                    fontFamily: "monospace",
                  }}
                >
                  Astro Trader Guide
                </Typography>
              </Link>
            </div>
          </Typography>

          {/* Profile Icon Section */}
          <IconButton
            onClick={handleProfileClick}
            style={{ marginLeft: "auto", padding: 0 }}
          >
            <Avatar style={{ width: '30px', height: '30px' }} alt="Profile" src="/path-to-profile-image.jpg" />
          </IconButton>

          {/* Optional Dropdown Menu */}
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            {/* <MenuItem onClick={handleClose}>Profile</MenuItem>
            <MenuItem onClick={handleClose}>Logout</MenuItem> */}
            <List style={{ paddingLeft: '5px', backgroundColor: 'rgba(255, 255, 255, 0.2)', }}>
              <ListItem button component={NavLink} to="/UserDashboard" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '30px' }}>
                <PersonIcon style={{ color: 'black' }} />  <ListItemText
                  primary="Profile"
                  primaryTypographyProps={{
                    style: {
                      color: "black",
                      cursor: "pointer",
                      fontFamily: "monospace",
                      textTransform: "uppercase",
                      fontSize: "12px",
                    },
                  }}
                />
              </ListItem>
              <ListItem button component={NavLink} to="/Logout" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '30px' }}>
                <FiLogOut style={{ color: 'red', marginLeft: '2px' }} /> <ListItemText
                  primary="Logout"
                  primaryTypographyProps={{
                    style: {
                      color: "black",
                      cursor: "pointer",
                      fontFamily: "monospace",
                      textTransform: "uppercase",
                      fontSize: "12px",
                      marginLeft: '5px'
                    },
                  }}
                />
              </ListItem>
            </List>
          </Menu>
        </Toolbar>
      </AppBar>;

      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerClose}
        PaperProps={{
          style: { backgroundColor: "#002029" },
        }}
      >
        <div style={{ fontWeight: "bold", marginTop: "10px" }}>
          <Typography
            variant="h6"
            component="div"
            style={{
              marginLeft: "15px",
              fontWeight: "bolder",
              color: "whitesmoke",
              fontFamily: "monospace",
              textTransform: "uppercase",
            }}
          >
            Astro Trade Guide
          </Typography>
        </div>
        <List>

          <ListItem button component={NavLink} to="/SubscriptionIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
            <ListItemText
              primary="Subscription Plans"
              primaryTypographyProps={{
                style: {
                  color: "white",
                  cursor: "pointer",
                  fontFamily: "monospace",
                  textTransform: "uppercase",
                  fontSize: "18px",
                },
              }}
            />
          </ListItem>

          <ListItem
            button
            component={NavLink}
            to="/UserForm"
            activeClassName="selected"
            onClick={handleDrawerClose}
            style={{ height: "40px" }}
          >
            <ListItemText
              primary="User"
              primaryTypographyProps={{
                style: {
                  color: "white",
                  cursor: "pointer",
                  fontFamily: "monospace",
                  textTransform: "uppercase",
                  fontSize: "18px",
                },
              }}
            />
          </ListItem>

          <ListItem
            button
            component={NavLink}
            to="/PlanetViewPage"
            activeClassName="selected"
            onClick={handleDrawerClose}
            style={{ height: "40px" }}
          >
            <ListItemText
              primary="Planet Position"
              primaryTypographyProps={{
                style: {
                  color: "white",
                  cursor: "pointer",
                  fontFamily: "monospace",
                  textTransform: "uppercase",
                  fontSize: "18px",
                },
              }}
            />
          </ListItem>
          
        </List>
      </Drawer>

      <Container maxWidth="xl">
        <Switch>
          {/* ✅ Default route (Login) */}
          <Route path="/" exact component={LoginPage} />

          {/* 🏠 Home route */}
          <Route path="/Home" component={Home} />

          {/* 📄 Other Routes */}
          <Route path="/SubscriptionForm" component={SubscriptionForm} />
          <Route path="/SubscriptionIndex" component={SubscriptionIndex} />
          <Route path="/UserForm" component={UserForm} />
          <Route path="/check-profile" component={CheckProfile} />
          <Route path="/complete-profile" component={CompleteProfile} />
          <Route path="/signup" component={SignupPage} />
          <Route path="/UserPlan/:id" component={UserPlan} />
          <Route path="/Payment/:id/:planid" component={Payment} />
          <Route path="/EditUserProfile/:id" component={EditUserProfile} />
          <Route path="/UserDashboard/:id" component={UserDashboard} />
          <Route path="/UserDashboard" component={UserDashboard} />
          <Route path="/PlanetViewPage" component={PlanetViewPage} />

        </Switch>
      </Container>
    </Router>
  );
};

export default App;
